import { render, staticRenderFns } from "./UtochPlanForm.vue?vue&type=template&id=ed263d96&scoped=true&"
import script from "./UtochPlanForm.vue?vue&type=script&lang=js&"
export * from "./UtochPlanForm.vue?vue&type=script&lang=js&"
import style0 from "./UtochPlanForm.vue?vue&type=style&index=0&id=ed263d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed263d96",
  null
  
)

export default component.exports